import { getAuthAxiosBackend } from "../../helpers/axios"

class InjuryServices{

    get(id){
        return getAuthAxiosBackend().get('plots-of-land-2/woundeds/'+id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('plots-of-land-2/woundeds', {params: data})
    }

    delete(id){
        return getAuthAxiosBackend().delete('plots-of-land-2/woundeds/' + id)
    }
}

export default new InjuryServices()